"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationModal = void 0;
exports.default = verify;
exports.refreshCookie = refreshCookie;
exports.validCredentials = validCredentials;
var _reactMintl = require("@godaddy/react-mintl");
var _react = _interopRequireWildcard(require("react"));
var _util = require("@ux/util");
var _ = _interopRequireDefault(require("./"));
var _button = _interopRequireDefault(require("@ux/button"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Check if the stored credentials still match that of the cookie.
 *
 * @param {Object} customer details.
 * @returns {Boolean} validity.
 * @api private
 */
function validCredentials(customer) {
  return _.default.idp.getIdpProperty('jti') === customer.get('jti');
}

/**
 * Verify the consistency of the current authentication credentials
 * against the cookie. This should prevent actions against wrong accounts if
 * impersonating multiple accounts.
 *
 * @param {Object} config Required configuration.
 * @param {Object} config.customer delegated customer data.
 * @returns {Boolean} true if credentials are valid, false if they are not
 * @api private
 */
function verify(config) {
  const customer = config.customer;

  //
  // If delegation is inactive or credentials are valid don't render modal warning.
  //
  if (!_.default.active || validCredentials(customer)) {
    return true;
  }
  return false;
}

/**
 * Issue a request to refresh the authentication cookie.
 *
 * @param {Object} config Required configuration.
 * @param {Object} config.customer delegated customer data.
 * @param {String} config.restoreCookie cookie to attempt to refresh from.
 * @param {Boolean} config.jsonp query with jsonp?
 * @param {Function} done Completion callback.
 */
function refreshCookie(config, done) {
  const {
    customer
  } = config;

  //
  // Try to refresh the cookie to check the known jti. Ignore errors from the
  // request so the modal will also be shown in that case.
  //
  _util.request.get(`${config.restoreCookie}?jti=${customer.get('jti')}`, {
    jsonp: config.jsonp === false ? config.jsonp : true
  }, error => {
    //
    // Credentials are still valid, notify the delegate that delegation is active.
    //
    if (!error && validCredentials(customer)) {
      return done(true);
    }
    done(false);
  });
}

/**
 * Render UXCore2 Modal if validation failed.
 *
 * @class Verify
 * @api public
 */
class VerificationModal extends _react.Component {
  render() {
    const props = this.props;
    const footer = !props.refreshFailed && /*#__PURE__*/_react.default.createElement(_button.default, {
      design: "primary",
      disabled: props.pending,
      onClick: !props.pending && props.onOk
    }, props.pending ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
      size: "sm",
      inline: true,
      shade: "dark"
    }) : /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:Common:OK"
    }));
    let message;
    if (!props.refreshFailed) {
      message = 'Shared:AccountDelegation:pageAuthRefreshMessage';
    } else {
      message = 'Shared:AccountDelegation:validateAuthMessage';
    }
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      footer: footer,
      title: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: "Shared:AccountDelegation:validateAuthTitle"
      }),
      onClose: props.onDismiss
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'verification-modal'
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:AccountDelegation:validateAuthShopper",
      values: props
    }), ' ', /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: message
    })));
  }
}

/**
 * Required properties for Modal message.
 *
 * @enum {Object}
 * @api public
 */
exports.VerificationModal = VerificationModal;
VerificationModal.propTypes = {
  /** shopper name passed to the validateAuthShopper message */
  displayName: _propTypes.default.string.isRequired,
  /** shopper ID passed to the validateAuthShopper message */
  shopperId: _propTypes.default.string.isRequired,
  /** ok button disabled and filled with spinner when true */
  pending: _propTypes.default.bool,
  /** whether or not the ok button renders and which message appears in the modal footer */
  refreshFailed: _propTypes.default.bool,
  /** modal closed handler */
  onDismiss: _propTypes.default.func,
  /** ok button click handler */
  onOk: _propTypes.default.func
};